import React, { StrictMode } from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { RecoilRoot } from "recoil";
import { GlobalStyle } from "./components/styles";
// 이외에 필요한 스타일 파일이 있다면 import 해주세요...

declare global {
  interface Window {
    webkit?: any;
    Android?: any;
    iOSGoogleLogin?: any;
    iOSAppleLogin?: any;
    requestIOSError?: (message: string) => void;
    getTokenIOS?: any;
    isPermissionedPhoto?: any;
    confirmPurchaseAndroid?: any;
    androidPurchasedFailed?: () => void; // 안드로이드 결제 에러
    androidPurchasedCanceled?: () => void; // 안드로이드 결제 취소
    requestIOSPurchase?: any;
    failIOSAlarm?: any;
    getNotificationStatus?: any;
    setFirst?: any;
    iOSAddPhoto?: any;
    iOSAddProfile?: any;
    iOSPurchasedFailed?: any;
    clearLocalStorage?: any;
    closeModalAtAndroid?: any;
    getFcmToken?: (token: string) => void; // FCM 토큰 전달
  }
}

ReactDOM.render(
  <StrictMode>
    <RecoilRoot>
      <GlobalStyle />
      <App />
    </RecoilRoot>
  </StrictMode>,
  document.getElementById("root")
);
